import React from "react";
import { usePermissions } from "../../hooks/usePermission";
import { Navigate, Outlet } from "react-router-dom";

interface PermissionWrapperProps {
  module: string;
  action?: string;
  // redirectTo?: string;
  children: React.ReactNode;
}

const PermissionWrapper: React.FC<PermissionWrapperProps> = ({
  module,
  action = "read",
  children,
  // redirectTo = "/unauthorized",
}) => {
  const { hasPermission } = usePermissions();

  if (!hasPermission(module, action)) {
    return <Navigate to="/unauthorized" replace />;
  }
  return <>{children}</>;
  // <Outlet />;
};

export default PermissionWrapper;
